// extracted by mini-css-extract-plugin
module.exports = {"detailWrapper":"MixedDetail_detailWrapper__2w4XA"};